import React, { useState, useEffect } from 'react'
import { Panel, Grid, Row, Col, Placeholder, Table } from 'rsuite'

export default function PromoteEatingFruitsAndVegetablesView({ schema: _schema }) {
  const { Graph } = Placeholder
  const { Column, HeaderCell, Cell } = Table
  const [dataList, setDataList] = useState([])
  const [schema, setSchema] = useState(_schema)

  useEffect(() => {
    setSchema(_schema)
    let dataList = []
    dataList.push(_schema.allStudents)
    dataList.push(_schema.thin)
    dataList.push(_schema.fat)
    dataList.push(_schema.short)
    dataList.push(_schema.slim)
    dataList.push(_schema.eatVegetableEnough)
    dataList.push(_schema.eatVegetableNotEnough)
    dataList.push(_schema.notEatVegetable)
    dataList.push(_schema.physicalActivity)

    setDataList(dataList)
  }, _schema)

  const renderEvent = schema?.activityList?.value.map((item, index) => {
    return (
      <>
        <p style={{ marginLeft: 10 }}>
          {schema.activityForm.activity.label + (index + 1)} <b>{item.activityName}</b>
        </p>

        {item.activityResult ? (
          <p style={{ marginLeft: 10 }}>
            {schema.activityForm.result.label} {item.activityResult}
          </p>
        ) : (
          <>
            <p style={{ marginLeft: 10 }}>{schema.activityForm.result.label}</p>

            <div style={{ marginLeft: 20 }}>
              <Graph height={9} width={'95%'} style={{ marginLeft: 10 }} />
              <Graph height={9} />
            </div>
          </>
        )}
      </>
    )
  })

  return (
    <>
      <Panel header="">
        <Grid fluid>
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} style={styles.marginTop10}>
              {schema.aboutSchool.value ? (
                <div
                  style={styles.dataStyles}
                  dangerouslySetInnerHTML={{ __html: schema.aboutSchool.value }}
                />
              ) : (
                <>
                  <Graph height={9} width={'95%'} style={{ marginLeft: '5%' }} />
                  <Graph height={9} />
                  <Graph height={9} />
                </>
              )}
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} style={styles.marginTop10}>
              <p>{schema.promoteNutritionResult.label}</p>

              {schema.promoteNutritionResult.value ? (
                <div
                  style={styles.dataStyles}
                  dangerouslySetInnerHTML={{ __html: schema.promoteNutritionResult.value }}
                />
              ) : (
                <>
                  <Graph height={9} width={'95%'} style={{ marginLeft: '5%' }} />
                  <Graph height={9} />
                  <Graph height={9} />
                </>
              )}
            </Col>

            <Col xs={24} sm={24} md={24} lg={24} style={styles.marginTop10}>
              <p>{schema.isActivity.label}</p>

              {schema.isActivity.value == 'N' && (
                <p style={{ marginLeft: 20 }}>
                  {
                    schema.isActivity.options?.find(
                      (item) => item.value === schema.isActivity.value
                    )?.label
                  }
                </p>
              )}
              {renderEvent}
            </Col>

            <Col xs={24} sm={24} md={24} lg={24} style={styles.marginTop20}>
              <p>
                <b>{schema.studentHealthInfoText}</b>
              </p>
            </Col>

            <Col xs={24} sm={24} md={24} lg={24} style={styles.marginTop10}>
              <Table rowKey="id" autoHeight wordWrap={true} data={dataList}>
                <Column width={150} flexGrow={1}>
                  <HeaderCell>ข้อมูล</HeaderCell>
                  <Cell dataKey="label" />
                </Column>
                <Column width={120} fixed="right">
                  <HeaderCell>จำนวน(คน)</HeaderCell>
                  <Cell dataKey="value" />
                </Column>
                <Column width={100} fixed="right">
                  <HeaderCell>ร้อยละ</HeaderCell>
                  <Cell>
                    {(rowdata) => {
                      return rowdata.value
                        ? ((rowdata.value * 100) / schema.allStudents.value).toFixed(2)
                        : '-'
                    }}
                  </Cell>
                </Column>
              </Table>
            </Col>

            {schema.sourceInfo && (
              <Col xs={24} sm={24} md={24} lg={24} style={styles.marginTop10}>
                <p>
                  {schema.sourceInfo.label}{' '}
                  {schema.sourceInfo.value ? <b>{schema.sourceInfo.value}</b> : '...........'}{' '}
                  {schema.sourceInfoMonth.label}{' '}
                  {schema.sourceInfoMonth.value ? (
                    <b>
                      {
                        schema.sourceInfoMonth.options?.find(
                          (item) => item.value == schema.sourceInfoMonth.value
                        )?.label
                      }
                    </b>
                  ) : (
                    '...........'
                  )}{' '}
                  {schema.sourceInfoYear.label}{' '}
                  {schema.sourceInfoYear.value ? (
                    <b>{schema.sourceInfoYear.value}</b>
                  ) : (
                    '...........'
                  )}
                </p>
              </Col>
            )}

            {schema.impactOfProblem && (
              <Col xs={24} sm={24} md={24} lg={24} style={styles.marginTop10}>
                <p>{schema.impactOfProblem.label}</p>
                {schema.impactOfProblem.value ? (
                  <div
                    style={styles.dataStyles}
                    dangerouslySetInnerHTML={{ __html: schema.impactOfProblem.value }}
                  />
                ) : (
                  <>
                    <Graph height={9} width={'95%'} style={{ marginLeft: '5%' }} />
                    <Graph height={9} />
                    <Graph height={9} />
                    <Graph height={9} />
                  </>
                )}
              </Col>
            )}

            {schema.effectOnStudents && (
              <Col xs={24} sm={24} md={24} lg={24} style={styles.marginTop10}>
                <p>{schema.effectOnStudents.label}</p>
                {schema.effectOnStudents.value ? (
                  <div
                    style={styles.dataStyles}
                    dangerouslySetInnerHTML={{ __html: schema.effectOnStudents.value }}
                  />
                ) : (
                  <>
                    <Graph height={9} width={'95%'} style={{ marginLeft: '5%' }} />
                    <Graph height={9} />
                    <Graph height={9} />
                    <Graph height={9} />
                  </>
                )}
              </Col>
            )}
          </Row>
        </Grid>
      </Panel>
    </>
  )
}

const styles = {
  personstyles: {
    width: 90,
    marginBottom: 5,
  },
  detailstyles: {
    width: 90,
  },
  rowStyles: {
    marginLeft: 20,
  },
  percentStyles: {
    width: 70,
    marginBottom: 5,
  },
  percentDetailStyles: {
    width: 70,
  },
  preLabelStyle: {
    width: '220px',
    textAlign: 'left',
  },
  leftWidth110: {
    width: '110px',
    textAlign: 'left',
  },
  marginTop10: {
    marginTop: 10,
  },
  marginTop20: {
    marginTop: 20,
  },
  dataStyles: { marginLeft: 10 },
}
